const NotificationTypes = [
  {
    label: "شروع تمرین",
    value: "StartExercise",
    variable: [
      "semesterId",
      "courseId",
      "exerciseId",
      "sessionId",
      "time",
      "operator",
    ],
    atribiute: {
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":time": "زمان",
      ":operator": "اپراتور",
    },
  },
  {
    label: "پایان تمرین",
    value: "EndExercise",
    variable: [
      "semesterId",
      "courseId",
      "exerciseId",
      "sessionId",
      "time",
      "operator",
    ],
    atribiute: {
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":time": "زمان",
      ":operator": "اپراتور",
    },
  },
  {
    label: "ددلاین تمرین",
    value: "DeadlineExercise",
    variable: ["courseId", "exerciseId", "sessionId", "time"],
    atribiute: {
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":time": "زمان",
      ":name": "نام",
      ":user-name": "نام کاربری",
    },
  },
  {
    label: "شروع دوره",
    value: "StartCourse",
    variable: [
      "semesterId",
      "courseId",
      "exerciseId",
      "sessionId",
      "time",
      "operator",
    ],
    atribiute: {
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":semester-name": "نام ترم(در صورت انتخاب یک ترم)",
      ":time": "زمان",
      ":user-name": "نام کاربری",
    },
  },
  {
    label: "پایان دوره",
    value: "EndCourse",
    variable: [
      "semesterId",
      "courseId",
      "exerciseId",
      "sessionId",
      "time",
      "operator",
    ],
    atribiute: {
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":semester-name": "نام ترم(در صورت انتخاب یک ترم)",
      ":time": "زمان",
      ":user-name": "نام کاربری",
    },
  },
  {
    label: "ثبت نام در دوره",
    value: "RegisterInCourse",
    variable: [
      "semesterId",
      "courseId",
      "exerciseId",
      "sessionId",
      "time",
      "operator",
    ],
    atribiute: {
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":semester-name": "نام ترم(در صورت انتخاب یک ترم)",
      ":time": "زمان",
      ":user-name": "نام کاربری",
    },
  },
  {
    label: "دوره فعال ",
    value: "ActiveCourse",
    variable: ["courseId"],
    atribiute: {
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":time": "زمان",
      ":user-name": "نام کاربری",
    },
  },
  {
    label: "خرید دوره",
    value: "BuyCourse",
    variable: ["courseId"],
    atribiute: { ":course-name": "نام دوره (در صورت انتخاب یک دوره)" },
  },
  {
    label: "پرداخت جریمه",
    value: "PayPenalty",
    variable: ["courseId", "exerciseId", "sessionId", "penaltyId"],

    atribiute: {
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":user-name": "نام کاربری",
      ":time": "زمان",
    },
  },
  {
    label: "شروع ترم",
    value: "StartSemester",
    variable: ["semesterId", "courseId", "exerciseId", "sessionId"],
    atribiute: {
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":semester-name": "نام ترم(در صورت انتخاب یک ترم)",
    },
  },
  {
    label: "پایان ترم",
    value: "EndSemester",
    variable: [
      "semesterId",
      "courseId",
      "exerciseId",
      "sessionId",
      "time",
      "operator",
    ],
    atribiute: {
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":semester-name": "نام ترم(در صورت انتخاب یک ترم)",
    },
  },
  {
    label: "ثبت نام در ترم",
    value: "RegisterInSemester",
    variable: [
      "semesterId",
      "courseId",
      "exerciseId",
      "sessionId",
      "time",
      "operator",
    ],
    atribiute: {
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":semester-name": "نام ترم(در صورت انتخاب یک ترم)",
    },
  },
  {
    label: "ترم فعال",
    value: "ActiveSemester",
    variable: ["semesterId"],
    atribiute: {
      ":semester-name": "نام ترم(در صورت انتخاب یک ترم)",
      ":user-name": "نام کاربری",
      ":time": "زمان",
    },
  },
  {
    label: "خرید ترم",
    value: "BuySemester",
    variable: ["semesterId"],
    atribiute: { ":semester-name": "" },
  },
  {
    label: "ایجاد جلسه ",
    value: "AddSession",
    variable: ["semesterId", "courseId"],
    atribiute: {
      ":semester-name": "نام ترم(در صورت انتخاب یک ترم)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":user-name": "نام کاربری",
      ":time": "زمان",
    },
  },
  {
    label: "مشاهده جلسه ",
    value: "SeenSession",
    variable: ["sessionId", "courseId"],
    atribiute: {
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":user-name": "نام کاربری",
      ":time": "زمان",
    },
  },
  {
    label: "ایجاد جریمه",
    value: "CreatePenalty",
    variable: ["semesterId", "courseId", "exerciseId"],
    atribiute: {
      ":session-name": "نام جلسه (در صورت انتخاب یک جلسه)",
      ":course-name": "نام دوره (در صورت انتخاب یک دوره)",
      ":exercise-name": "نام تمرین (در صورت انتخاب یک تمرین)",
      ":user-name": "نام کاربری",
      ":time": "زمان",
    },
  },
];

export default NotificationTypes;
